

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface DischargeAdviceParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface DischargeAdvice {
    id?: any;
    regId:any;
    date:Date;
    admissionId:any;
    departmentId:any;
    physicianId:any;
    adviceNotes:string;
   // ampm:string;
    expectedDischargeDate:any;
    expectedDischargeTime:any; 
    cancelFlag:string;
    cancelReason:string;
    zeroDischargeFlag:string;
    zeroDischargeDoneBy:number;

    zeroBillReason?:string;
    apprMode?:string;
    apprEmpId?:string;
    apprDocId?:string;
   
    tenantId: any;
    branchId: any;
  
  parameters?: DischargeAdviceParameter[];
  links?: any;
  createdDate?:Date;
  createdBy?:number;
  visitId?:number;
}

export abstract class DischargeAdviceData {
  abstract getById(url: string): Observable<DischargeAdvice>;
  abstract list(url: string): Observable<DischargeAdvice[]>;
  abstract create(url: string, data: DischargeAdvice): Observable<DischargeAdvice[]>;
  abstract update(url: string, data: DischargeAdvice): Observable<DischargeAdvice>;
  abstract delete(url: string): Observable<any>;
 
}
